// Чистая логика авторазрешения состояния слоя (тестируется без DOM/maplibre).
import type { Availability } from '../api'

export type ReadinessAction =
  | 'show-colored' // есть отрендеренные тайлы (или статика) → показать цветной сразу
  | 'grey-generate' // данные есть, тайлов нет → серый + запустить генерацию + докрашивание
  | 'wait-button' // ни тайлов, ни данных → ждать «Загрузить»

/** Availability → действие фронта.
 *
 * Если тайлы уже отрендерены (tiles_ready) — показываем их, даже когда охват
 * вьюпорта частичный (data_present=false): нельзя вешать «Слой не загружен»
 * поверх видимого цветного тайла. Кнопка «Загрузить» остаётся доступной, чтобы
 * догрузить недостающий охват. Это НЕ фолбэк к протухшим данным — data_present
 * означает неполное покрытие области, а не устаревшие тайлы. */
export function readinessAction(av: Availability): ReadinessAction {
  if (av.is_static || av.tiles_ready) return 'show-colored'
  if (av.data_present) return 'grey-generate'
  return 'wait-button'
}

/** Добавить cache-buster к шаблону тайлов, чтобы MapLibre перезапросил тайлы при рефреше. */
export function bustedTileUrl(base: string, v: number): string {
  return base + (base.includes('?') ? '&' : '?') + 'v=' + v
}
